module.exports = __webpack_public_path__ + "static/img/20231208_08.23c662c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2023/20231208_08.png
// module id = OXJZ
// module chunks = 0